import { actions, paths } from "../../../../common/constants";

export default {
  getTransactions: ({
    asc = false,
    orderBy = "createdAt",
    limit = 10,
    start_at,
    keyword,
  }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_TRANSACTIONS_REQUEST,
        actions.GET_TRANSACTIONS_SUCCESS,
        actions.GET_TRANSACTIONS_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.TRANSACTIONS, {
          params: { asc, orderBy, limit, start_at, keyword },
        }),
    },
  }),

  getTransactionDetail: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_TRANSACTION_DETAIL_REQUEST,
        actions.GET_TRANSACTION_DETAIL_SUCCESS,
        actions.GET_TRANSACTION_DETAIL_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.build(paths.api.v1.TRANSACTIONS_ID, id)),
    },
  }),

  deleteTransaction: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.TRANSACTION_DELETE_REQUEST,
        actions.TRANSACTION_DELETE_SUCCESS,
        actions.TRANSACTION_DELETE_FAILURE,
      ],
      promise: (client) =>
        client.delete(paths.api.v1.TRANSACTIONS_ID, { params: { id } }),
    },
  }),

  updateTransaction: (id, transaction) => ({
    [actions.CALL_API]: {
      types: [
        actions.TRANSACTION_UPDATE_REQUEST,
        actions.TRANSACTION_UPDATE_SUCCESS,
        actions.TRANSACTION_UPDATE_FAILURE,
      ],
      promise: (client) =>
        client.put(paths.build(paths.api.v1.TRANSACTIONS_ID, id), transaction),
    },
  }),
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/transactions.js